




































































import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { RectangleLayer } from "@/model/document2/page/surface/design/layer/rectangleLayer";
import { CircleLayer } from "@/model/document2/page/surface/design/layer/circleLayer";
import { PolygonLayer } from "@/model/document2/page/surface/design/layer/polygonLayer";

import { ColorConstruct } from "@/utilityModels/colorConstruct";

@Component({
    components: {
    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class PatternFillColorController extends Vue 
{
    @Prop() layer! : RectangleLayer | CircleLayer | PolygonLayer;

    // 選択カラーインデックス
    private selectedColorIndex = 0;

    // カラー0が空か?
    private get isTransparent0()
    {
        // 塗りつぶし : なし
        return this.layer.fillType == 0;
    }

    // カラー1が空か?
    private get isTransparent1()
    {
        // 塗りつぶし : なし or 単色
        return this.layer.fillType == 0 || this.layer.fillType == 1;
    }

    private toStyleColor(color : ColorConstruct)
    {
        return "rgb(" + color.r + "," + color.g + "," + color.b + ")";
    }

    // カラー0
    private get color0()
    {
        if(this.layer.fillType == 1)
        {
            return this.toStyleColor(this.layer.fillColor);
        }
        else if(this.layer.fillType == 2)
        {
            if(this.layer.getGradationPointCount() > 0)
            {
                return this.toStyleColor(this.layer.getGradation(0).color);
            }
        }

        return "transparent";
    }

    // カラー1
    private get color1()
    {
        if(this.layer.fillType == 2)
        {
            if(this.layer.getGradationPointCount() > 1)
            {
                return this.toStyleColor(this.layer.getGradation(this.layer.getGradationPointCount() - 1).color);
            }
        }

        return "transparent";
    }

    private invisibleColor()
    {
        if(this.selectedColorIndex == 0)
        {
            if(this.layer.fillType == 1)
            {
                // 塗りつぶし
                this.changeLayerProperty("fillType", 0, true, true);
            }
            else if(this.layer.fillType == 2)
            {
                // グラデーション
                if(this.layer.getGradationPointCount() > 1)
                {
                    this.changeLayerProperty("fillType", 1, false, false);
                    this.changeLayerProperty("fillColor", this.layer.getGradation(1).color, true, false);
                }
            }
        }
        else if(this.selectedColorIndex == 1)
        {
            if(this.layer.fillType == 2)
            {
                // グラデーション
                if(this.layer.getGradationPointCount() > 0)
                {
                    this.changeLayerProperty("fillType", 1, false, false);
                    this.changeLayerProperty("fillColor", this.layer.getGradation(0).color, true, false);
                }
            }
        }
    }

    private changeColor(hex : string)
    {
        var hexContent = hex.substr(0, 1) == "#" ? hex.substr(1, 6) : hex; 
        var r = parseInt(hexContent.substr(0, 2), 16);
        var g = parseInt(hexContent.substr(2, 2), 16);
        var b = parseInt(hexContent.substr(4, 2), 16);

        var color = new ColorConstruct(r, g, b);
        if(this.selectedColorIndex == 0)
        {
            if(this.layer.fillType == 0)
            {
                // なし
                this.changeLayerProperty("fillType", 1, false, false);
                this.changeLayerProperty("fillColor", color, true, false);
            }
            else if(this.layer.fillType == 1)
            {
                // 塗りつぶし
                this.changeLayerProperty("fillColor", color, true, true);
            }
            else if(this.layer.fillType == 2)
            {
                // グラデーション
                if(this.layer.getGradationPointCount() > 0)
                {
                    this.changeGradationColor(0, color, true);
                }
            }
        }
        else if(this.selectedColorIndex == 1)
        {
            if(this.layer.fillType == 0)
            {
                // なし
                this.changeLayerProperty("fillType", 1, false, false);
                this.changeLayerProperty("fillColor", color, true, false);
                this.selectedColorIndex = 0;
            }
            else if(this.layer.fillType == 1)
            {
                // 塗りつぶし
                if(this.layer.getGradationPointCount() > 1)
                {
                    this.changeLayerProperty("fillType", 2, false, false);
                    this.changeGradationColor(0, this.layer.fillColor, false);
                    this.changeGradationColor(this.layer.getGradationPointCount() - 1, color, true);
                }
            }
            else if(this.layer.fillType == 2)
            {
                // グラデーション
                if(this.layer.getGradationPointCount() > 1)
                {
                    this.changeGradationColor(this.layer.getGradationPointCount() - 1, color, true);
                }
            }
        }
    }

    private requestColor()
    {
        // プロパティ設定
        var property = "";
        var currentColor = new ColorConstruct();
        if(this.selectedColorIndex == 0)
        {
            if(this.layer.fillType == 0 || this.layer.fillType == 1)
            {
                // なし or 塗りつぶし
                property = "fillColor";
                if(this.layer.fillType == 1) { currentColor = this.layer.fillColor; }
            }
            else if(this.layer.fillType == 2)
            {
                // グラデーション
                if(this.layer.getGradationPointCount() > 0)
                {
                    property = "gradationStartColor";
                    currentColor = this.layer.getGradation(0).color;
                }
            }
        }
        else if(this.selectedColorIndex == 1)
        {
            if(this.layer.fillType == 0)
            {
                // なし
                property = "fillColor";
            }
            else if(this.layer.fillType == 1 || this.layer.fillType == 2)
            {
                // 塗りつぶし or グラデーション
                if(this.layer.getGradationPointCount() > 1)
                {
                    property = "gradationEndColor";
                    if(this.layer.fillType == 2) { currentColor = this.layer.getGradation(this.layer.getGradationPointCount() - 1).color; }
                }
            }
        }
        if(property != "")
        {
            this.$emit("requestColor", property, currentColor);
        }
    }

    // グラデーションを90度回転
    private rotateGradation()
    {
        var newAngle = this.layer.linearGradationAngle + 90;
        if(newAngle >= 360) { newAngle -= 360; }

        this.changeLayerProperty("linearGradationAngle", newAngle, true, true);
    }

    private changeLayerProperty(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        this.$emit("changeLayerProperty", propertyName, value, isFinish, isOnce);
    }

    private changeGradationColor(index : number, value : ColorConstruct, isFinish : boolean)
    {
        this.$emit("changeGradationColor", index, value, isFinish);
    }
}
